import moment from "moment";

const paramsDefaultSearchHistories = [
  {
    id: "secitm",
    name: "Student end course in this month",
    filter: {
      "filter[ends_between_newest_course]":
        moment().startOf("month").format("YYYY-MM-DD") +
        "," +
        moment().endOf("month").format("YYYY-MM-DD"),
    },
  },
  {
    id: "sefitm",
    name: "Student end freezing in this month",
    filter: {
      "filter[studentCourses.etFreezings.ends_between]":
        moment().startOf("month").format("YYYY-MM-DD") +
        "," +
        moment().endOf("month").format("YYYY-MM-DD"),
    },
  },
  {
    id: "arlm",
    name: "Attendance record last month",
    filter: {
      "filter[with_statis_enrollment_attended_schedules]":
        moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD") +
        "," +
        moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
    },
  },
  {
    id: "sdsa",
    name: "Alumni",
    filter: {
      "filter[left_school]": 1,
    },
  }
];

export default function getDefaultSearchHistories() {
  return paramsDefaultSearchHistories;
}
